import { useTranslation } from 'react-i18next';
import { Box, Typography, useTheme } from '@mui/material';
import aiMusicGenerator from 'services/locales/en/aiMusicGenerator';
import { useSubscription } from 'services/hooks';
import {
  personalAccountMaxDate,
  proAccountMaxDate,
  minDate,
} from './constants';

const DurationLimit = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { isPersonalAccount } = useSubscription();

  const maxDate = isPersonalAccount
    ? personalAccountMaxDate
    : proAccountMaxDate;

  return (
    <Box>
      <Typography
        sx={{
          color: theme.palette.grey[400],
          fontSize: 12,
        }}
      >
        {t(aiMusicGenerator.durationSelector.description, {
          min: minDate.format('mm:ss'),
          max: maxDate.format('mm:ss'),
        })}
      </Typography>
    </Box>
  );
};

export default DurationLimit;
